import { render, staticRenderFns } from "./EditSupplierPage.vue?vue&type=template&id=9ab40856"
import script from "./EditSupplierPage.vue?vue&type=script&lang=js"
export * from "./EditSupplierPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports